export default "__VITE_ASSET__S42wkW2q__"